<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gJQNsB/tc-custom/9781558617834.jpg?1702686048419" alt="This image is the cover for the book Silent Duchess"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent Duchess
      </h1>
      <p class="bookDescription body article font2">
        <b>The stunning English translation of the International Man Booker Prize Finalist novel hailed as “a story of grace and endurance, not mere survival” (<i>The New York Times Book Review</i>).</b><br/>  <br/> Winner of the Premio Campiello, short-listed for the Independent Foreign Fiction Award, and published to critical acclaim in fourteen languages, this “spellbinding” historical novel by one of Italy’s premier authors is now available in this luminous new translation (<i>Booklist</i>).<br/>  <br/> In early 18th century Sicily, noblewoman Marianna Ucrìa is trapped in a world of silence after a terrible childhood trauma left her deaf and mute. Married off to a lecherous uncle, she struggles to educate and elevate herself against all convention—and find her true place in a world that sees her as little more than property.<br/>  <br/> In language that conveys the keen vision and deep human insight possessed by her protagonist, Dacia Maraini captures the splendor and the corruption of Marianna’s world, as well as the strength of her unbreakable spirit, in “one of those rare, rich, deep, strange novels that create a world so fantastic and so real you want to start reading it again as soon as you come to the last page” (<i>Newsday</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dacia Maraini, Anna Camaiti Hostert
      </h2>
      
      <p class="authorDescription body article">One of Italy's foremost women writers, Dacia Maraini was a finalist for the International Man Booker prize, the winner of the international Prix Formentor and the Premio Campiello, one of Italy's highest literary honors. She is the author of more than fifty books, including novels, plays, collections of poetry, and critical essays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Feminist Press at CUNY
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37839ff4